import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2, inject } from '@angular/core';
import { Router } from '@angular/router';

type ElementRefHTML = ElementRef<HTMLElement>;

@Directive({
  selector: '[portalClickableChipLink]',
  standalone: false,
})
export class ClickableChipDirective implements OnInit, AfterViewInit {
  private readonly element: ElementRefHTML = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly router = inject(Router);

  @Input() portalClickableChipLinkEnabled = true;
  @Input() portalClickableChipLink: string;
  originalText?: HTMLSpanElement;

  @HostListener('click', ['$event']) onClick(_event: MouseEvent) {
    if (this.originalText instanceof HTMLSpanElement && this.portalClickableChipLinkEnabled) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([this.portalClickableChipLink], { queryParams: { returnUrl: this.router.url } }),
      );
      globalThis.open(url, '_blank');
    }
  }

  ngOnInit(): void {
    this.originalText = this.element.nativeElement.querySelector('.chip-label');
  }

  ngAfterViewInit(): void {
    if (!this.originalText) {
      this.originalText = this.element.nativeElement.querySelector('.chip-label');
    }

    if (this.originalText?.innerText?.length && this.portalClickableChipLinkEnabled) {
      this.wrapTextInLink();
    }
  }

  private wrapTextInLink(): void {
    const link = this.renderer.createElement('a');
    const text: HTMLSpanElement = this.renderer.createElement('span');
    text.innerHTML = this.originalText.innerHTML;
    this.renderer.setAttribute(link, 'href', this.portalClickableChipLink);
    this.renderer.setAttribute(link, 'target', '_blank');
    this.renderer.addClass(link, 'chip-label');
    this.renderer.appendChild(link, text);
    this.originalText.replaceWith(link);
  }
}
